import { io } from "socket.io-client";
import { getEnv } from "./env";

let socketInstance = null;

export const getSocket = (token) => {
  if (!socketInstance) {
    socketInstance = getEnv("REACT_APP_SOCKET_URL")
      ? io(getEnv("REACT_APP_SOCKET_URL"), {
          extraHeaders: {
            Authorization: `Bearer ${token}`,
          },
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 5000,
          timeout: 20000,
        })
      : io({
          extraHeaders: {
            Authorization: `Bearer ${token}`,
          },
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 5000,
          timeout: 20000,
        });
  }
  return socketInstance;
};

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};
